import { BaseInput, BaseInputProps } from "../primitive/BaseInput"

export interface TextInputProps extends Omit<BaseInputProps, "type"> {
    value: string;
    onValueChange: (newValue: string) => void;
}

export const TextInput = (props: TextInputProps) => {
    return (
        <BaseInput
            type="text"
            {...props}
            onValueChange={val => props.onValueChange(String(val))}
        />
    )
}